// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__3DdEJ","logo":"Navbar_logo__tJYc7","navLinks":"Navbar_navLinks__Br-Bu","navItem":"Navbar_navItem__TQeWq"};